/* tslint:disable */
/* eslint-disable */
/**
 * MINDD STIM 3
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PrescriptionBrowsing } from './prescription-browsing';

/**
 * 
 * @export
 * @interface Browsing
 */
export interface Browsing {
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'birthdate': string;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'creationTime': string;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'id': string;
    /**
     * 
     * @type {PrescriptionBrowsing}
     * @memberof Browsing
     */
    'latestPrescription'?: PrescriptionBrowsing;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'memo': string;
    /**
     * 
     * @type {string}
     * @memberof Browsing
     */
    'sex': BrowsingSexEnum;
}

export const BrowsingSexEnum = {
    None: 'NONE',
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type BrowsingSexEnum = typeof BrowsingSexEnum[keyof typeof BrowsingSexEnum];


